import { EnvironmentOutlined } from '@ant-design/icons';
import { List } from 'antd';
import moment from 'moment';
import { ReactNode } from 'react';

import { SosStatus } from '@/graphql';

import styles from './SosItem.module.css';

type PaymentBreakdown = {
    rate: number;
    total: number;
    cardFee: number;
    smsCost: number;
    twillioGbp: number;
    twilllioFee: number;
    potntialTotal: number;
    twilllioSellingFee: number;
};

type Props = {
    actions?: ReactNode[];
    createdAt: string;
    distance: number;
    id: string;
    message: string;
    status: SosStatus;
    isDeleted?: boolean | null;
    isItemPaid?: boolean | null;
    paidPrice?: number | null;
    paymentBreakdown?: PaymentBreakdown | null;
    paymentId?: string | null;
    user?: {
        id: string;
        name: string;
        email: string;
        mobile: string;
        createdAt: string;
        emailVerified: boolean;
        location: string;
        mySos?: Array<{
            createdAt: string;
            distance: number;
            id: string;
            message: string;
            status: SosStatus;
            isDeleted?: boolean | null;
        } | null> | null;
    } | null;
};

const SosItem = ({ actions = [], createdAt, distance, id, message, status, user, isItemPaid, paymentId, paidPrice = 0, paymentBreakdown }: Props) => {
    const postedPrefix = status === SosStatus.Approved ? 'Sent' : 'Submitted';
    const postedElement = createdAt ? (
        <>
            {postedPrefix} {moment(createdAt).fromNow()}
        </>
    ) : undefined;

    const getStripePaymentUrl = (paymentIntentId: string) => {
        return `https://dashboard.stripe.com/payments/${paymentIntentId}`;
    };

    return (
        <List.Item actions={[postedElement, ...actions]} className={styles.item} key={`list-item-${id}`}>
            <List.Item.Meta
                description={
                    <div>
                        <p>
                            <em>{message}</em>
                        </p>
                        <div style={{ textAlign: 'left', marginTop: '5px' }}>{message.length}/150 characters</div>
                        {user ? (
                            <div className={styles.userDetails}>
                                <p>
                                    <b className={styles.titleText}>Created By:</b> {user.name}
                                </p>
                                <p>
                                    <b className={styles.titleText}>Email:</b> {user.email}
                                </p>
                                <p>
                                    <b className={styles.titleText}>Phone:</b> {user.mobile}
                                </p>
                                <p>
                                    <span style={{ marginRight: '10px' }}>
                                        <b className={styles.titleText}>Cost Price:</b> £{paymentBreakdown?.twilllioFee?.toFixed(2)}
                                    </span>
                                    <span style={{ marginRight: '10px' }}>
                                        <b className={styles.titleText}>Sell Price:</b> £{paymentBreakdown?.twilllioSellingFee?.toFixed(2)}
                                    </span>
                                    <span style={{ marginRight: '10px' }}>
                                        <b className={styles.titleText}>Stripe Fee:</b> £{paymentBreakdown?.cardFee?.toFixed(2)}
                                    </span>
                                    <span style={{ marginRight: '10px' }}>
                                        <b className={styles.titleText}>Total:</b> £{paymentBreakdown?.total?.toFixed(2) || (paidPrice != null ? (paidPrice / 100).toFixed(2) : 0)}
                                        {paymentId ? (
                                            <a href={getStripePaymentUrl(paymentId)} target="_blank" rel="noopener noreferrer" className={styles.titleLink}>
                                                View Payment
                                            </a>
                                        ) : null}
                                    </span>
                                </p>
                                <p>
                                    {isItemPaid !== true ? (
                                        <span style={{ marginRight: '10px', color: 'red', textDecoration: 'underline' }}>
                                            <b>NOT PAID</b>
                                        </span>
                                    ) : null}
                                </p>
                            </div>
                        ) : null}
                    </div>
                }
                title={
                    <>
                        <EnvironmentOutlined /> {distance} Miles
                    </>
                }
            />
        </List.Item>
    );
};

export { SosItem };
